import React, { Fragment } from 'react';
import Loading from 'components/loading';

const Evaluate = () => (
  <Fragment>
    <div className="hiring-evaluate-target-list loading">
      <div className="hiring-evaluate-target-target">
        <span>Loading</span>
      </div>
      <div className="hiring-evaluate-target-target">
        <span>Loading</span>
      </div>
      <button className="hiring-evaluate-target-list-add button-white" disabled>
        <span>+</span>
      </button>
    </div>
    <Loading />
  </Fragment>
);

export default Evaluate;
